import { useState } from 'react';
import { logException, postMessageHelper } from 'Utils';
import { withLogin } from 'Components/hocs';
import IconSvg from 'Components/IconSvg';
const LOGOUT_REDIRECT_URL = process.env.REACT_APP_LOGOUT_REDIRECT_URL;
const LOGOUT_REDIRECT_URL_TIMEOUT = Number(
  process.env.REACT_APP_LOGOUT_REDIRECT_URL_TIMEOUT
);
const setIcon = (message, success) => {
  if (message && !success)
    return <IconSvg type="error" className="icon--error" />;
  return <IconSvg type="checkmark" className="icon--success" />;
};

const LogoutSuccess = (props) => {
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  const logout = async () => {
    try {
      await props.uim.logout();
      postMessageHelper.send({
        type: postMessageHelper.types.LOGOUT_SUCCESS,
        payload: props.strings.loggedOut,
      });
      setSuccess(true);
      setMessage(props.strings.loggedOut);
      setTimeout(() => {
        window.location.href = LOGOUT_REDIRECT_URL;
      }, LOGOUT_REDIRECT_URL_TIMEOUT);
    } catch (err) {
      logException(e);
      setMessage(props.strings.errorLoggedOut);
    }
  };

  logout();

  return (
    <>
      <div className="icon-heading">{setIcon(message, success)}</div>
      <h1 className="page-heading">{message}</h1>
    </>
  );
};

export default withLogin(LogoutSuccess);
